export const PICKING_STATUS = Object.freeze({
  new: { label: 'Новое', color: 'default' },
  in_progress: { label: 'В работе', color: 'primary' },
  completed: { label: 'Закрыто', color: 'success' },
  cancelled: { label: 'Отменено', color: 'error' },
});

/** Статусы, которые видит кладовщик в списке подбора */
export const ACTIVE_PICKING_STATUSES = Object.freeze(['new', 'in_progress']);

export function isActivePickingStatus(status) {
  return ACTIVE_PICKING_STATUSES.includes(status);
}

export function pickingProgress(job = {}) {
  const total = Math.max(0, Number(job.items_total) || 0);
  const picked = Math.min(total, Math.max(0, Number(job.items_picked) || 0));
  return { total, picked, percent: total ? Math.round((picked / total) * 100) : 0 };
}

export function chooseDefaultPickingJob(jobs = []) {
  return jobs.find((job) => isActivePickingStatus(job.status)) || jobs[0] || null;
}
